export default class MobileNavigation {
  constructor() {
    this.toggle = document.querySelector('[data-nav-toggle]');
    this.menu = document.querySelector('[data-nav-menu]');
    this.overlay = null;
    this.isOpen = false;
    this.lastFocusedElement = null;
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  init() {
    if (!this.toggle || !this.menu) {
      return;
    }

    this.overlay = document.createElement('div');
    this.overlay.className = 'mobile-nav-overlay';
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.append(this.overlay);
    this.toggle.addEventListener('click', () => this.toggleMenu());
    this.overlay.addEventListener('click', () => this.close());
    this.menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        this.close(false);
      }
    });
    document.addEventListener('keydown', this.handleKeydown);
    window.addEventListener('resize', this.handleResize, { passive: true });
  }

  toggleMenu() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.lastFocusedElement = document.activeElement;
    this.toggle.classList.add('is-active');
    this.toggle.setAttribute('aria-expanded', 'true');
    this.toggle.setAttribute('aria-label', 'Cerrar menú');
    this.menu.classList.add('is-open');
    this.overlay.classList.add('is-visible');
    document.body.classList.add('menu-open');
    this.menu.querySelector('a')?.focus();
  }

  close(restoreFocus = true) {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.toggle.classList.remove('is-active');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.setAttribute('aria-label', 'Abrir menú');
    this.menu.classList.remove('is-open');
    this.overlay.classList.remove('is-visible');
    document.body.classList.remove('menu-open');

    if (restoreFocus) {
      this.lastFocusedElement?.focus();
    }
  }

  handleKeydown(event) {
    if (!this.isOpen) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusable = [...this.menu.querySelectorAll('a[href], button:not([disabled])')];
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  handleResize() {
    if (window.innerWidth >= 1024) {
      this.close(false);
    }
  }
}
